<template>
  <div>
    <static-how-it-works />
    <static-footer :pageObj="howItWorks"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StaticFooter from '@/components/Footer/StaticFooter'
import StaticHowItWorks from '@/components/StaticPages/StaticHowItWorks'

export default {
  name: 'HowItWorks',
  components: {
    StaticHowItWorks,
    StaticFooter,
  },
  computed: {
    ...mapGetters(['_T', 'all_static_pages']),
    howItWorks() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(page => page.slug === 'how-it-works')
      }
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>

.about-us {
  .us-img {
    position: relative;
    margin-bottom: $px90;

    .us-w {
      width: 94%;
    }

    .us-back {
      opacity: 0.2;
      z-index: -1;
      position: absolute;
      bottom: -$px90;
      left: -$px60;
    }
  }

  .trending-blog {
    .blog-title {
      h2 {
        text-align: left;
        margin-bottom: calc(
          #{$px20} + (42 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );

        &::after {
          margin: 0;
        }
      }
    }

    p {
      font-size: $px16;
      line-height: $px29;
      letter-spacing: 0.005em;
      margin-bottom: 0;
    }
  }

  &.how-work {
    .v2-work-img {
      img {
        transform: scaleX(-1);
      }
    }

    .row {
      align-items: center;
    }
  }
}

.value-section {
  background-color: rgba(var(--color-light-border-source), 0.2);
  .help-card {
    margin-top: 0;
  }
}
</style>
